import React, { FC, ReactNode } from 'react';

import { Box } from '@material-ui/core';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';
import cx from 'classnames';

import CloseIcon from '../../assets/icons/CloseIcon';
import { LOGO_TRANSFORMATION } from '../Header/Header';
import IKImage from '../IKImage/IKImage';
import useStyles from './styles';

interface OverlayWrapperProps {
  opened: boolean;
  handleClose: () => void;
  logoUrl?: string;
  wrapperClass?: string;
  children?: ReactNode;
  startBreakpoint?: Breakpoint;
}

const OverlayWrapper: FC<OverlayWrapperProps> = ({
  opened,
  handleClose,
  logoUrl,
  wrapperClass,
  children,
  startBreakpoint = 'md',
}) => {
  const classes = useStyles(startBreakpoint)();

  return (
    <Box className={cx(classes.overlay, opened && classes.overlayOpened, wrapperClass)}>
      <Box className={cx(classes.overlayLogoWrapper, 'overlay-tenant-logo__wrapper')}>
        {logoUrl && (
          <IKImage
            path={logoUrl || ''}
            draggable={false}
            alt={'logo'}
            transformation={LOGO_TRANSFORMATION}
          />
        )}
      </Box>
      <CloseIcon className={classes.overlayCloseIcon} onClick={handleClose} />
      <Box className={classes.contentWrapper}>{children}</Box>
    </Box>
  );
};

export default OverlayWrapper;
